//============================================================================
// Name        : shipments_transfer_details.ts
// Purpose     : Implement shipments transfer detail page
// Created     : 2021-04-20
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import { InitPage } from "../index";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";

class ShipmentsTransferDetails {
  init() {
    const _this = this;
    let resData = 0;
    let detailIds = [];
    const clientCode = $("#client_code").val();
    const store = $("#store_code").val();
    const slipId = $("#slip_id").val();

    function select_tag(ele) {
      const values = [];
      detailIds = [];
      $.each($("input[name='killTag[]']:checked"), function() {
        values.push($(this).val());
        detailIds.push($(this).data("trans"));
      });
      const path = "/" + clientCode + "/" + store + "/alerts/epc_data";
      const tableData = [];
      $.get(path, { epc_ids: values, client_code: clientCode, store_code: store }, (data, status) => {
        resData = data.data;
        $.each(resData, (k, v) => {
          tableData.push("<tr>" +
            "<td class='text-center'>" + (v[2] || "-") + "</td>" +
            "<td class='text-center'>" + (v[6] || "-") + "</td>" +
            "<td class='text-center'>" + (v[1] || "-") + "</td>" +
            "<td class='text-center'>" + (v[3] || "-") + "</td>" +
            "<td class='text-center'><span class='label label-pending-gray line-height-28' style='background-color: #A6A6A6!important;'>Pending</span></td>" +
            "</tr>");
        });
        $("#count_epcs").html(data.count);
        $("#kill-tag").html(tableData.join(""));

        $("#epc-count").html(data.count);
        $("#remove-tags-table").html(tableData.join(""));
      });
    }

    function create_note() {
      var formDataArray = $('#createNoteForm').serializeArray();
      var formDataObject = array_to_object(formDataArray);
      var formDataJSON = JSON.stringify(formDataObject);
      const path = "/" + clientCode + "/" + store + "/transactions/transfer_details/" + slipId + "/transfer_notes";
      axios.post(path, formDataJSON, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(function(response) {
        const note = response.data.transfer_note;
        $('#transferNotesTBody').prepend(`
                <tr>
                  <td class="text-left double-lines-content">
                    ${moment(note.created_at).format('MM/DD/YYYY')}
                    <br/>
                    ${moment(note.created_at).format('h:mm A')}
                  </td>
                  <td  class="text-left">
                    ${note.important ? '<i class="fa fa-check sn-text-warning"></i>' : ''}
                  </td>
                  <td class="text-left" style="width: 80%">
                    <span title="${note.note}" data-toggle="tooltip" data-placement="top">${note.note}</span>
                  </td>
                </tr>
            `);
        $('#noteFormMessage').val('');
        $('#noteFormImportant').removeAttr("checked");
      }).catch(function(error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
        $('#noteFormMessage').val('');
        $('#noteFormImportant').removeAttr("checked");
      });
    }

    function array_to_object(array) {
      var result = {};
      array.forEach(function(item) {
        var keys = item.name.split('[');
        var currentObj = result;
        keys.forEach(function(key, index) {
          key = key.replace(']', '');
          if (index === keys.length - 1) {
            currentObj[key] = item.value;
          } else {
            currentObj[key] = currentObj[key] || {};
            currentObj = currentObj[key];
          }
        });
      });

      return result;
    }

    function change_status() {
      $("button.kill").prop('disabled', true);
      const reasonVal = $("#reason").val();
      const killPath = "/" + clientCode + "/" + store + "/alerts/kill_tag";
      $.post(killPath, { epc_data: resData, reason: reasonVal, client_code: clientCode, store_code: store, alert: detailIds, slip_id: slipId }, (data, status) => {
        window.location.href = window.location.href;
      });
    }

    function remove_selected_tags() {
      const pinNumber = $("#pin_number").val().toString().trim();
      const removeTagsPath = "/" + clientCode + "/" + store + "/transactions/transfer_out/remove_tags";

      if (!pinNumber) {
        swal({ text: "Please Enter your PIN#", icon: "warning" });
        return;
      }

      const epcIdsArr = Array(resData)[0].map(arr => arr[arr.length - 1]);
      if (epcIdsArr.length <= 0) {
        swal({ text: "No tags selected. Please choose one or more tags to remove", icon: "warning" });
        return;
      }

      const epcIds = epcIdsArr.join(",");

      $("#btn-remove-selected-tags").prop('disabled', true);
      $.post(removeTagsPath, {
        epc_ids: epcIds,
        pin_number: pinNumber,
        client_code: clientCode,
        store_code: store,
        slip_id: slipId
      }, (data, status) => {
        location.reload();
      }).fail((xhr, status, error) => {
        swal({ text: xhr.responseJSON.message, icon: "warning" });
        $("#btn-remove-selected-tags").prop('disabled', false);
      });
    }

    function escape_html(value) {
      return $("<div>").text(value || "").html();
    }

    function load_print_preview(logId) {
      const path = "/" + clientCode + "/" + store + "/transactions/transfer_details/" + slipId + "/transfer_logs/" + logId + "/preview";

      $("#printPreview").modal("show");
      $("#print-preview-content").html(`
        <div class="text-center">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
          <p>Loading label preview...</p>
        </div>
      `);

      $.ajax({
        url: path,
        method: "GET",
        dataType: "json",
        success: (data) => {
          const imageHtml = data.image
            ? `<div class="text-center" style="margin-bottom: 15px"><img src="${data.image}" style="max-width: 100%; border: 1px solid #ddd" /></div>`
            : `<div class="alert alert-info text-center">Label image preview is unavailable.</div>`;
          const zplHtml = `<pre style="max-height: 250px; overflow: auto; background: #f5f5f5; padding: 10px; white-space: pre-wrap">${escape_html(data.zpl)}</pre>`;
          $("#print-preview-content").html(imageHtml + zplHtml);
        },
        error: () => {
          $("#print-preview-content").html(`
            <div class="alert alert-warning text-center">
              <i class="fa fa-exclamation-triangle"></i>
              Error loading label preview
            </div>
          `);
        },
      });
    }

    $(() => {
      $(document).on("click", ".print-preview-icon", function(e) {
        e.preventDefault();
        const logId = $(e.currentTarget).data("log-id");
        if (logId) load_print_preview(logId);
      });
    });
    $(() => {
      $("#kill-select-btn").click(select_tag);
    });
    $(() => {
      $("#remove-select-btn").click(select_tag);
    });
    $(() => {
      $("button.kill").click(change_status);
    });
    $(() => {
      $("#btn-remove-selected-tags").click(remove_selected_tags);
    });
    $(() => {
      $("#createNoteBtn").click(create_note);
    });
    $(() => {
      $("#createNoteForm").submit(function(event) {
        create_note
        event.preventDefault();
      });
    });
  }
}

export function LoadPage() {
  InitPage("transfer_details", () => {
    const shipmentsTransferDetails = new ShipmentsTransferDetails();
    shipmentsTransferDetails.init();
  });
}
